<template>
     <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" >
         <div class="row align-center">
            <div class="col-2 col-sm-1 py-0 pl-5  pl-md-5 text-center rounded">
                <img :src="`${require('@/assets/Sedes-CDA.png')}`" class="img-dialog-description">
            </div>
            <div class="col-10 col-sm-11 pt-0 pl-10 pl-md-0 orange--text">
                <div class="font-weight-black orange--text col pt-1 font-title text-md-h4 text-sm-h4 text-h5" style="line-height:1"><i>CENTRO DE APLICACIONES</i></div>
                <div class='graylight--text col font-title text-h5 text-sm-h4' style="line-height:0"><b>Sede Guayaquil</b></div>
            </div>
        </div>
        <v-col cols="12" class="grayblack--text font-text"  style='display: inline-block;'>
            En virtud de asegurar su comodidad, lo invitamos a concurrir a nuestros centros de aplicaciones,
            <br />
            donde podrá recibir la administración de terapias biológicas, hierros, antibióticos, vitaminas e hidrataciones
            <br />
            o bien la medicina que requiera.
        </v-col>
        <v-col cols="12"  class="grayblack--text ">
            <b>Av. Francisco de Orellana y Justino Cornejo, Guayaquil, Ecuador</b>
            <br />
            <i>(Edif. World Trade Center, planta baja, Local 14)</i>

            <p class="pt-5">Abierto de lunes a viernes de 9 a 18 hs y sábados de 9 a 13 hs.</p>
        </v-col>
        <v-col cols="12">
            <v-responsive>
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15947.89237693024!2d-79.8976979!3d-2.1639403!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5d19cfa4bfc48505!2sInnofarm%20-%20Medicina%20Integral%20de%20Especialidad!5e0!3m2!1ses!2sec!4v1616426952960!5m2!1ses!2sec" 
                    width="800" 
                    height="300" 
                    style="border:0;border-radius: 10px;" 
                    allowfullscreen="" 
                    loading="lazy"
                >
                </iframe>
            </v-responsive>
        </v-col>
  </div>
</template>

<script>
export default {
    name: 'AplicationsCenterUioComponent',
    data:()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Sedes',url:'/sedes'},
            {name:'Centro de aplicaiciones guayaquil',url:'/sedes/centro-aplicaciones-guayaquil'}
        ],
    }),
    created(){
        this.$emit('newBreadcrumbs',this.breadcrumbs)
    }
}
</script>

<style>
.v-application .text-sm-h4, .v-application .text-h5{
        font-family: Asap!important
    }
</style>